module.exports = {"jobEndpoint":"/api/getJob","fileEndpoint":"/api/getFile","submitEndpoint":"/api/submit"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 256
// module chunks = 0